import { Trans } from '@lingui/react/macro';
import { CreditCard } from '@remarkable/ark-icons';

import { Button, Modal } from 'src/components';

import { CloudConnectEditPaymentMethodModal } from './CloudConnectEditPaymentMethodModal';

export const CloudConnectChangePaymentMethodButton = ({
  componentLocation,
  isVerifying,
}: {
  componentLocation: string;
  isVerifying: boolean;
}) => (
  <Modal.Root>
    <Modal.Trigger asChild>
      <Button
        variant="tertiary"
        size="medium"
        className="w-full whitespace-nowrap ls:w-fit"
        data-cy="change-payment-card-button"
        loading={isVerifying}
        disabled={isVerifying}
        analytics={{
          text: 'Change payment card',
          location: componentLocation,
          action: 'open change payment card modal',
        }}
      >
        <CreditCard />
        <span>
          <Trans>Change payment method</Trans>
        </span>
      </Button>
    </Modal.Trigger>

    <CloudConnectEditPaymentMethodModal componentLocation={componentLocation} />
  </Modal.Root>
);
